import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import SessionConfig from "../../config/session_config"
import { useTranslation } from "react-i18next"
import { is_empty } from "../../config/validate"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import "./fileReq.scss"
import dictionary from "../../config/dictionary"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import Select from "react-select"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Button,
  ButtonGroup,
  Badge,
  CardTitle,
  Label,
  InputGroup,
  Input,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import showToast from "../../components/Common/viewNotification"
import {
  getFilesRequirement,
  getTypesArea,
  getTypesFiles,
  deleteFile,
  cleanDataFile,
} from "../../store/actions"
import FileRequirementForm from "./FileRequirementForm"
import FileRequirementDelete from "./FileRequirementDelete"

const FileRequirement = () => {
  const ref = useRef()
  const [data, setData] = useState({
    columns: [],
    selectedRows: [],
    page: 0,
    size: 10,
  })
  const [toggleSwitch, settoggleSwitch] = useState(false)
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [currentFile, setCurrentFile] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [clearSelectedRows, setclearSelectedRows] = useState(false)
  const [selectRows, setSelectRows] = useState([])
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [area, setArea] = useState({ value: "", label: "", error: "" })
  const [nameFile, setNameFile] = useState({ value: "", error: "" })
  // header title
    document.title = t("files:title") + " | " + t("global:title")
  //#region  store
  const { responseDelete, loading, error, filesList, fileTypeList, areaList } =
    useSelector(state => ({
      filesList: state.fileRequirement.fileList,
      fileTypeList: state.fileRequirement.fileTypeList,
      areaList: state.fileRequirement.areaList,
      loading: state.fileRequirement.loading,
      responseDelete: state.fileRequirement.responseDelete,
    }))

  useEffect(() => {
    document.title = t("files:title") + " | " + t("global:title")
    document.getElementById("body").className = "fondo2"
    initTable()
    loadData()
  }, [data.page, data.size])

  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])
  const toggle = () => {
    setModal(!modal)
  }
  const loadData = async () => {
    let body = {
      length: data.size,
      page: data.page,
      area: area.value,
      fileName: nameFile.value,
    }
    await dispatch(getFilesRequirement(body))
    await dispatch(getTypesArea(dictionary.configApp.concept.areaCode))
    await dispatch(getTypesFiles(dictionary.configApp.concept.fileType))
  }

  useEffect(() => {
    if (responseDelete !== null) {
      if (responseDelete.length > 0) {
        showToast(
          t("global:msgSuccessDeleteList"),
          "success",
          t("banks:titleModal")
        )
        dispatch(cleanDataFile())
        loadData()
      }
    }
  }, [responseDelete])

  const handlePageChange = async page => {
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.page, "page")
  }
  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.size, "size")
    await updateState(data.page, "page")
  }
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    })
  }
  const initTable = () => {
    data.columns = [
      {
        name: t("files:titleNameFile"),
        sortable: false,
        wrap: true,
        grow: 4,
        cell: row => (
          <div>
            <div className=" "><Badge
              color={
                row.requirementTypeFile.code ===
                  dictionary.configApp.type.required
                  ? "danger text-uppercase"
                  : "primary  text-uppercase"
              }
            >
              {row.requirementTypeFile.name}
            </Badge> {row.fileName}</div>
            <div>

              <span className="text-muted">{row.updateFrequency}</span>
            </div>
          </div>
        ),
      },


      {
        name: t("files:titleAreaSupplier"),
        sortable: false,
        wrap: true,
        grow: 2,
        cell: row => <div>
          {row.supplier?.name}
          <h6 className="text-muted">{row.area?.name}</h6></div>,
      },
      {
        name: t("materialSupplier:titleSingle"),
        sortable: false,
        wrap: true,
        grow: 2,
        cell: row => <div className=" text-lowercase">{row?.material?.description}
        <div><Badge>{row?.material?.codeSap}</Badge></div></div>,
      },
      {
        name: "Accion",
        width:"100px",
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="fa fa-edit font-size-18"
                id="edittooltip"
                onClick={() => editFile(row)}
              ></i>
            </Link>
          </div>
        ),
      },
    ]
  }
  const editFile = row => {
    setCurrentFile(row)
    setIsEdit(true)
    toggle()
  }
  const addFile = () => {
    setCurrentFile(null)
    setIsEdit(false)
    toggle()
  }
  const onClosing = () => {
    setModal(!modal)
  }
  const handleRowSelected = React.useCallback(state => {
    setSelectRows(state.selectedRows)
  }, [])
  const changeStatus = async () => {
    setclearSelectedRows(true)
    await dispatch(deleteFile(selectRows))
    setclearSelectedRows(false)
    setSelectRows([])
  }

  const handleDelete = () => {
    changeStatus()
    setShowDeleteModal(false)
  }

  const handleClose = () => {
    setShowDeleteModal(false)
  }
  const areaLs = () => {
    if (areaList.length > 0) {
      return areaList?.map(item => {
        return { value: item.id, label: item.name }
      })
    } else {
      return []
    }
  }
  const changeArea = value => {
    if (value === null) {
      setArea({ value: "", label: "" })
    } else {
      setArea({ value: value.value, label: value.label })
    }
  }
  const contextActions = React.useMemo(() => {
    return (
      <React.Fragment>
        <Form>
          <Row>
            <Col>
              <Button
                key="delete"
                color={toggleSwitch ? t("primary") : t("danger")}
                disabled={loading}
                onClick={() => setShowDeleteModal(true)}
              >
                {toggleSwitch ? t("supplier:enabled") : t("supplier:disabled")}
              </Button>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  })
  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("files:title")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="h5 mb-4 text-primary">
                    {t("files:filterTitle")}
                  </CardTitle>
                  <Row>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="name">{t("files:titleArea")}</Label>
                        <Select
                        isClearable
                          name="area"
                          options={areaLs()}
                          value={area}
                          onChange={value => changeArea(value)}
                        />
                        <span className="small text-danger">{area.error}</span>
                      </div>
                    </Col>

                    <Col lg={4}>
                      <Label htmlFor="name">{t("files:titleNameFile")}</Label>

                      <InputGroup>
                        <Input
                          autoComplete="new-text"
                          type="text"
                          className="form-control"
                          value={nameFile.value || ""}
                          onChange={e => {
                            setNameFile({ value: e.target.value, error: "" })
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-primary save-user"
                          disabled={loading}
                          onClick={loadData}
                        >
                          <i className=" fas fa-search me-1 " />
                        </button>
                      </InputGroup>
                    </Col>
                    <Col
                      lg={4}
                      className="d-flex justify-content-end align-items-end"
                    >
                      <ButtonGroup>
                        <Button
                          color="primary"
                          className="font-16 btn-block btn btn-primary"
                          onClick={addFile}
                        >
                          <i className="fas fa-plus-circle me-1" />
                          {t("global:add")}
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                  <Row>
                    <DataTable
                      title={
                        <label className="text-primary text-uppercase font-size-16">
                          <i className="fa fa-list font-size-18  me-1 " />
                          {t("files:titleAdd")}
                        </label>
                      }
                      data={
                        filesList?.fileRequirementList
                          ? filesList.fileRequirementList
                          : ""
                      }
                      columns={data.columns}
                      fixedHeaderScrollHeight="500px"
                      selectableRows

                      onSelectedRowsChange={handleRowSelected}
                      pointerOnHover={true}
                      highlightOnHover
                      pagination
                      paginationServer
                      paginationTotalRows={filesList ? filesList.size : 0}
                      paginationDefaultPage={1}
                      onChangePage={handlePageChange}
                      paginationComponentOptions={{
                        rowsPerPageText: t("tableOptions:rowsPerPageText"),
                        rangeSeparatorText: t(
                          "tableOptions:rangeSeparatorText"
                        ),
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t(
                          "tableOptions:selectAllRowsItemText"
                        ),
                      }}
                      noDataComponent={t("tableOptions:noDataComponent")}
                      progressPending={loading}
                      progressComponent={<LinearIndeterminate />}
                      contextActions={contextActions}
                      persistTableHead
                      onChangeRowsPerPage={handlePerRowsChange}
                      clearSelectedRows={clearSelectedRows}
                      contextMessage={{
                        singular: t("tableOptions:singular"),
                        plural: t("tableOptions:plural"),
                        message: "",
                      }}
                    />
                    <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
                      <ModalHeader
                        toggle={toggle}
                        tag="h4"
                        close={<span></span>}
                      >
                       <div> {isEdit ? t("files:titleEditModal")  : t("files:titleModal")}
                        <div className="text-secundary small"> {isEdit ? currentFile?.fileName : ""}
                        
                       </div>
                       </div>
                      </ModalHeader>
                      <ModalBody>
                        <FileRequirementForm
                          fileTypeList={fileTypeList}
                          onClosing={onClosing}
                          currentFile={currentFile}
                          onLoad={loadData}
                        />
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={showDeleteModal}
                      toggle={handleDelete}
                      backdrop={"static"}
                      size="xl"
                    >
                      <ModalHeader
                        toggle={handleDelete}
                        tag="h4"
                        close={<span></span>}
                      >
                        {t("files:titledelete")}
                      </ModalHeader>
                      <ModalBody>
                        <FileRequirementDelete
                          selectRows={selectRows}
                          handleDelete={handleDelete}
                          handleClose={handleClose}
                        />
                      </ModalBody>
                    </Modal>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default FileRequirement
